// extracted by mini-css-extract-plugin
module.exports = {"modal_footer":"selected-client_modal_footer__3WloU","button_container":"selected-client_button_container__2ZnZ5","delete":"selected-client_delete__1Glan"};